<template>
  <section class="iv-pos-r">
  <div
    class="iv-tree-search-wrapper iv-m-b-16"
    v-if="showSearch">
    <Select
      style="position: relative"
      :class="changeTree ? 'iv-fullwidth' : ''"
      class="iv-filterable-select"
      filterable
      remote
      clearable
      ref="Select"
      :placeholder="treePlaceHolder"
      @on-clear="onSelectClear"
      @on-change="onSearchChange"
      @on-query-change="onQueryChange"
      @keydown.native.enter="searchTreeList()">
      <Option v-for="(option, index) in treeResultList" :value="option.id" :key="index">{{option.title}}</Option>
    </Select>
    <Spin style="position: absolute;
      right: 46px;
      bottom: 6px;" v-if="spinShow">
    </Spin>
    <IconFont
      v-if="changeTree"
      @click="changeTreeWidth"
      class="iv-icon-spread iv-fs-16 iv-pointer iv-hover-color"
      :type="treeCollapse ? 'outdent' : 'indent'"></IconFont>
    </div>
    <!--  -->
    <Tree
      style="height: calc(100vh - 210px); overflow: auto;"
      ref="Tree"
      :style="treeStyle"
      :nodes="treeData"
      :setting="setting"
      @onCreated="handleCreated"
    >
    </Tree>
    <Spin
      fix
      size="large"
      v-if="showSpin"></Spin>
  </section>
</template>
<script>
import IconFont from '@/components/iconfont'
import {treeType, TreeType} from './tree-type'
import collapseTreeMixin from '@/mixins/collapse-tree'
import DynamicSelectMixin from './select-mixin'
import {SyncSearch, AsyncSearch} from './search'
import { iconMap, iconGongMap, iconTuanMap } from './treeTypeMap'
import Tree from './vue-giant-tree.common'
import {prefixPath} from '@/config'
export default {
  mixins: [collapseTreeMixin, DynamicSelectMixin],
  props: {
    treePlaceHolder: {
      type: String,
      default: '输入后回车搜索'
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    getTreeAction: {
      type: Function
    },
    data: {
      type: Array
    },
    // 需传三个接口函数
    treeCustomData: {
      type: Object
    },
    treeParams: {
      type: Object,
      default () {
        return {}
      }
    },
    treeUrl: {
      type: String,
      default: ''
    },
    treeStyle: {
      type: Object,
      default () {
        return {}
      }
    },
    changeTree: {
      type: Boolean,
      default: true
    },
    actionAsync: {
      type: Boolean,
      default: false
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    checkStrictly: {
      type: Boolean,
      default: false
    },
    renderContent: {
      type: Function
    },
    treeType: {
      type: Object,
      default () {
        return {
          type: 'single-all',
          scope: '',
          disabledOrgCategorys: ''
        }
      }
    },
    async: {
      type: Boolean,
      default: false
    },
    treeMap: {
      type: Object,
      default () {
        return {}
      }
    },
    showTreeIcon: {
      type: Boolean,
      default: true
    },
    isInitialSelect: { //是否获取请求后自动选中第一个节点
      type: Boolean,
      default: true
    },
    isRootDisabled: { // 根组织是否不可选
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      ztreeObj: null,
      spinShow: false,
      nodeData: {},
      treeResultList: [],
      treeData: this.data,
      searchResultMap: new Map(),
      requestGroup: {},
      currentQuery: '',
      currentSelect: null,
      showSpin: true,
      treeRender: this.renderContent || this.defaultRender,
      rootIds: []
    }
  },
  watch: {
    data (val) {
      this.treeData = val
    },
    renderContent (render) {
      this.treeRender = render
    }
  },
  components: {
    IconFont,
    Tree
  },
  created () {
    this.bizLineCode = this.$route.query.bizLineCode || ''
    this.requestGroup = treeType.getGroup(this.treeType.type)
    this.init()
    this.getTreeList()
    let searchAction = this.async ? AsyncSearch.prototype : SyncSearch.prototype
    Object.getOwnPropertyNames(searchAction).forEach(key => {
      if (key === 'constructor') return
      this[key] = searchAction[key].bind(this)
    })
  },
  methods: {
    // 初始化
    init () {
      this.setting = {
        treeObj: null,
        data: {
          key: {
            name: 'title',
            title: 'title',
            children: 'children'
          },
          render: {
            name: this.treeRender
          }
        },
        view: {
          showTitle: true,
          showLine: false,
          showIcon: false,
          nameIsHTML: true
        },
        check: {
          chkStyle: 'checkbox',
          chkboxType: { 'Y': this.checkStrictly ? 's' : '', 'N': this.checkStrictly ? 's' : '' }, // 级联 p(关联父)，s(关联子)
          enable: this.showCheckbox // 是否开启选择框
        },
        async: {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-XSRF-TOKEN': sessionStorage.getItem('token'),
            'Authorization': `Bearer ${sessionStorage.getItem('token') || ''}`
          },
          autoParam: (this.treeCustomData && Object.keys(this.treeCustomData).length != 0) ? this.switchCustomParams('auto') : ['id=rootId'],
          otherParam: this.switchCustomParams(),
          enable: this.async,
          type: 'get',
          //项目负责人的树 去掉api-platform 前缀
          url: this.treeType?.type === 'async-change' ? this.requestGroup.list : prefixPath + this.requestGroup.list,
          dataFilter: this.ajaxDataFilter
        },
        callback: {
          onClick: (e, node, treeNode) => {
            this.onSelectChange([treeNode])
          },
          onCheck: (e, treeId, treeNode) => {
            this.onCheckChange([treeNode])
          },
          beforeExpand: (treeId, treeNode) => {
            if (treeNode.isParent && !treeNode.children.length) {
              this.ztreeObj.reAsyncChildNodes(treeNode, 'refresh', true)
            }
          },
          beforeAsync: (treeId, treeNode) => {
            return !!treeNode
          }
        }
      }
    },
    // 转换请求数据
    switchCustomParams (type) {
      if (this.treeCustomData && Object.keys(this.treeCustomData).length != 0) {
        if (type) {
          return this.setArrayUrl(this.treeCustomData.getListParamsAuto())
        }
        return this.setArrayUrl(this.treeCustomData.getListParamsAutoOther())
      }
      return this.setArrayUrl(TreeType.getListParams({
        showRoot: false,
        level: 1,
        selectId: '',
        disabledIds: this.treeParams.disabledIds,
        scope: this.treeParams.scope,
        disabledOrgCategorys: this.treeParams.disabledOrgCategorys,
        bizLineCode: this.treeParams.bizLineCode ? this.treeParams.bizLineCode: this.bizLineCode || 'YWX01',
        _csrf: sessionStorage.getItem('token')
      }))
    },
    // 数组转换
    setArrayUrl (obj) {
      for (let key in obj) {
        if (Array.isArray(obj[key])) {
          let str = ''
          obj[key].forEach((item, inx) => {
            if (inx === (obj[key].length - 1)) {
              str += item
            } else {
              str += item + '&' + key + '='
            }
          })
          str = str.substr(0, str.length - 1)
          obj[key] = str
        }
      }
      return obj
    },
    // 对 异步 Ajax 返回数据进行预处理
    ajaxDataFilter (treeId, parentNode, responseData) {
      if (!responseData) return null
      this.additionLoading(responseData.data)
      return responseData.data
    },
    // 初始化操作 && 展开第一个节点
    handleCreated (ztreeObj) {
      this.ztreeObj = ztreeObj
      if (this.treeParams.selectId) {
        if (this.showCheckbox && Array.isArray(this.treeParams.selectId)) {
          this.treeParams.selectId.forEach(item => {
            let node = this.ztreeObj.getNodeByParam('id', item)
            let dataPath = node?.data?.dataPath.replace(/^\/|\/$/g, '').split('/')
            if (dataPath) {
              for (let i = 0; i < dataPath.length; i++) {
                this.ztreeObj.expandNode(this.ztreeObj.getNodeByParam('id', dataPath[i]), true, false, true)
              }
            }
          })
        } else {
          this.ztreeObj.selectNode(this.ztreeObj.getNodeByParam('id', this.treeParams.selectId))
          this.currentSelect = this.ztreeObj.getNodeByParam('id', this.treeParams.selectId)
        }
        return
      }
      this.ztreeObj.selectNode(ztreeObj.getNodes()[0])
    },
    /*
    * @description loop data
    */
    transferData (item = this.treeData, transfer) {
      let queue = [...item]
      while (queue.length) {
        let queueItem = queue.shift()
        if (queueItem.children) {
          queue.push(...queueItem.children)
        }
        transfer(queueItem)
      }
    },
    rebuildTree (data) {
      this.ztreeObj.refresh()
    },
    resetNode (node, status) {
      node.checked = status
      if (node.id != '-1') {
        // node.open = status
        this.ztreeObj.expandNode(node, true, false, true)
      }
      node.children && node.children.length && node.children.map(val => {
        this.resetNode(val, status)
      })
    },
    resetTree () {
      let newTreeData = JSON.parse(JSON.stringify(this.treeData[0]))
      this.resetNode(newTreeData, false)
      this.$set(this.treeData, 0, newTreeData)
    },
    /*
    * @description get tree data by interface tools
    */
    getTreeList (openNode, key) {
      const action = this.getTreeAction ? data => {
        return this.getTreeAction(data).then(data => ({data}))
      } : data => this.$ajax({
        url: this.async ? this.requestGroup.list : this.treeUrl,
        method: this.async ? 'get' : 'GET',
        data: this.async ? (this.treeCustomData && Object.keys(this.treeCustomData).length != 0) ? this.treeCustomData.getListParams() : TreeType.getListParams({
          rootId: data[this.treeMap.key],
          showRoot: data.showRoot != undefined ? data.showRoot : true,
          level: 1,
          disabledIds: data.disabledIds,
          selectId: data.selectId,
          disabledOrgCategorys: data.disabledOrgCategorys,
          scope: data.scope,
          bizLineCode: data.bizLineCode || 'YWX01'
        }, data) : data
      })
      action({bizLineCode: this.bizLineCode || this.treeParams.bizLineCode || 'YWX01', ...this.treeParams}).then(({data}) => {
        if (this.treeParams.showRoot != false) {
          data.data.length && (data.data[0].open = true)
        } else {
          data.data.length && (data.data[0].open = false)
        }
        this.initRootFlag(data.data)
        this.async && this.additionLoading(data.data, 'initial')
        this.treeData = this.filterData(data.data)
        if ((this.treeParams.selectId == '' || this.treeParams.selectId == undefined) && this.treeParams.showRoot != false) {
          data.data[0].selected = true
        }
        if (this.treeParams.selectId) {
          this.currentSelect = this.ztreeObj.getNodeByParam('id', this.treeParams.selectId)
        } else {
          this.currentSelect = this.treeData[0]
        }
        if (this.isInitialSelect) {
          this.$emit('on-select-change', data.data)
        }
        this.showSpin = false
      })
    },
    initRootFlag (data) {
      this.rootIds = data.map(d => {
        d.isRoot = true
        d.disabled = this.isRootDisabled
        return d.id
      })
    },
    filterData (data) {
      if (this.async) return data
      data.forEach(item => {
        if (item.children && item.children.length) {
          this.filterData(item.children)
          return
        }
        item.children = null
      })
      return data
    },
    /*
    * @description addition loading field，this field will be remove when backend
    */
    additionLoading (data = [], type = '') {
      let isInitial = type === 'initial'
      this.transferData(data, (item) => {
        !item.leaf && (item.loading = false)
        if (this.nodeData[item.id] == undefined) {
          this.nodeData[item.id] = item
        }
        Object.assign(item, item.data || {})
        if (isInitial && item.level == 1) {
          item.open = true
        }
      })
      this.$emit('on-nodeData', this.nodeData)
      //
    },
    searchQueryPage (addiction = false) {
      this.spinShow = true
      if (!addiction) {
        this.selectCurrentPage = 1
      }
      return this.$ajax({
        url: this.requestGroup.query,
        method: 'GET',
        data: (this.treeCustomData && Object.keys(this.treeCustomData).length != 0) ? this.treeCustomData.getQueryParams(this.currentQuery, this.selectCurrentPage) : TreeType.getQueryParams({
          rootId: this.treeParams.orgId,
          title: this.currentQuery,
          currentPage: this.selectCurrentPage,
          bizLineCode: this.treeParams.bizLineCode ? this.treeParams.bizLineCode: this.bizLineCode || 'YWX01',
          pageSize: 10
        })
      }).then(({data}) => {
        // no addiction case, we can operator
        if (!addiction) {
          this.treeResultList = data.data
        }
        this.selectCurrentMaxPage = data.maxPage
        this.$refs.Select.visible = true
        return data
      }).finally(() => {
        this.spinShow = false
      })
    },
    updateTree (action = 'add', origin, item, parent = {}, index, isSilent) {
      if (index !== 0) {
        index = -1
      }
      if (action === 'delete') {
        let nodes = (origin.children || []).find(child => child.id === item.id)
        this.ztreeObj.removeNode(nodes)
      } else if (action === 'add') {
        this.ztreeObj.addNodes(origin, index, item)
      } else if (action === 'move') {
        this.ztreeObj.moveNode(item, origin, 'prev')
      } else {
        this.ztreeObj.updateNode(Object.assign(origin, item))
      }
      if (isSilent) {
        this.reAsyncChildNodes(origin)
      }
    },
    /*
    * @description tree node click events
    */
    onSelectChange (items, type) {
      this.currentSelect = items[0]
      this.$emit('on-select-change', items, type)
    },
    getCheckedNodes () {
      return this.ztreeObj.getCheckedNodes(true)
    },
    getSelectedNodes () {
      return this.ztreeObj.getSelectedNodes()
    },
    setSelectedNodes (id) {
      this.ztreeObj.selectNode(this.ztreeObj.getNodeByParam('id', id))
      this.currentSelect = this.ztreeObj.getNodeByParam('id', id)
    },
    getByIdNode (id) {
      return this.ztreeObj.getNodeByParam('id', id)
    },
    getTreeRootNode () {
      return this.ztreeObj.getNodes()[0] || []
    },
    setCheckNode (node, status) {
      this.ztreeObj.checkNode(node, !!status, false)
    },
    setCheck (status) {
      // 只设置了关联子
      let _status = (status != undefined) ? status : this.checkStrictly
      let type = { 'Y': _status ? 's' : '', 'N': _status ? 's' : '' }
      this.ztreeObj.setting.check.chkboxType = type
    },
    // tree node check events
    onCheckChange (item) {
      let items = this.ztreeObj.getCheckedNodes(true)
      this.$emit('on-check-change', items, item)
    },
    changeSelectStatus (node) {
      node && (this.ztreeObj.selectNode(node))
      let dataPath = (node?.data?.dataPath || this.currentSelect?.data?.dataPath).replace(/^\/|\/$/g, '').split('/')
      if (dataPath) {
        for (let i = 0; i < dataPath.length; i++) {
          this.ztreeObj.expandNode(this.ztreeObj.getNodeByParam('id', dataPath[i]), true, false, true)
        }
      }
      this.ztreeObj.checkNode(this.ztreeObj.getNodeByParam('id', this.currentSelect.id), true)
      this.ztreeObj.selectNode(this.ztreeObj.getNodeByParam('id', this.currentSelect.id))
    },
    defaultRender (name, treeNode) {
      if (!this.showTreeIcon) return treeNode.title
      const bizLineCode = this.treeParams.bizLineCode || this.bizLineCode
      const map = {
        'YWX01': 'dang',
        'YWX03': '-gonghui',
        'YWX04': 'rutuan'
      }
      if (bizLineCode === 'YWX05' || bizLineCode === 'YWX06') {
        return this.noIconTree(treeNode)
      }
      return this.setPartyBuildingIcon(name, treeNode, map[bizLineCode])
    },
    //党建的图标
    setPartyBuildingIcon (name, treeNode, icon = 'dang') {
      const bizLineCode = this.treeParams.bizLineCode || this.bizLineCode
      const iconMapLocal = bizLineCode == 'YWX01' ? iconMap : (bizLineCode == 'YWX03' ? iconGongMap : iconTuanMap)
      return `<i style="color: #f00" class="icon iconfont icon-${treeNode.isRoot ? icon : iconMapLocal[treeNode.orgCategoryCode || (treeNode.data && treeNode.data.orgCategoryCode)]} iv-symbol-mr8 iv-fs-16"></i>
              <span>${treeNode.title}</span>`
    },
    //不带图标的
    noIconTree (treeNode) {
      return `<span>${treeNode.title}</span>`
    },
    reAsyncChildNodes (treeNode) {
      this.ztreeObj.expandNode(this.ztreeObj.getNodeByParam('id', this.currentSelect.id), true, false, true, true)
      this.ztreeObj.checkNode(this.ztreeObj.getNodeByParam('id', this.currentSelect.id), true)
      this.ztreeObj.selectNode(this.ztreeObj.getNodeByParam('id', this.currentSelect.id))
      this.ztreeObj.reAsyncChildNodes(treeNode, 'refresh', true)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/base/variables/symbol.scss';
/deep/ .ztree {
  .button {
    width: 20px !important;
    &.chk {
      width: 14px !important;
    }
    &.checkbox_true_part:after,
    &.checkbox_true_part_focus:after {
      top: 1px !important;
      left: 4px !important;
      // width: 8px !important;
      width: 4px !important;
      height: 8px !important;
      -webkit-transform: rotate(45deg) scale(1) !important;
      transform: rotate(45deg) scale(1) !important;
      border-right: 2px solid #fff !important;
    }
    &.bottom_close:before,
    &.bottom_open:before,
    &.center_close:before,
    &.center_open:before,
    &.noline_close:before,
    &.noline_open:before,
    &.root_close:before,
    &.root_open:before,
    &.roots_close:before,
    &.roots_open:before {
      border-width: 5px !important;
      border-left-width: 6px !important;
      border-right-width: 6px !important;
    }
  }
  li {
    margin: $iv-symbol-m8 0 !important;
    a {
      height: 24px !important;
      line-height: 24px !important;
    }
    a:hover {
      color: inherit !important;
    }
    .node_name {
      line-height: 24px;
    }
  }
}
.iv-tree-search-wrapper {
  position: relative;
  .iv-filterable-select {
    &.iv-fullwidth {
      padding-right: 24px;
    }
  }
  .iv-icon-spread {
    position: absolute;
    right: 0;
    top: 3px;
  }
  /deep/ .iv-icon-wrapper {
    padding: 2px 4px;
  }
  /deep/ .iv-tree-selected {
    border-radius: 2px;
  }
  /deep/ .iv-icon {
    position: relative;
    top: 2px;
    margin-right: 4px;
  }
}
/deep/ .ivu-tree-empty {
  padding: 16px;
  text-align: center;
}
</style>
